import React, { useEffect } from 'react';
import Head from 'next/head';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import Signup from '../components/Auth/Signup';
import * as FlashActions from '../actions/flash';
import { withTranslation } from 'next-i18next';
import GuestConstraintRoute from '../RouteConstraint/GuestConstraint';
import { serverSideTranslations } from '@lib/i18n';
import { TFunction } from 'i18next';

interface SignupWrapperProps {
  t: TFunction;
  flashActions: any;
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    flashActions: bindActionCreators<any, any>(FlashActions, dispatch),
  };
}

const SignupWrapper = (props: SignupWrapperProps) => {
  const { t, flashActions } = props;
  const router = useRouter();
  // biome-ignore lint/correctness/useExhaustiveDependencies: Only run on mount to show flash message if redirected from booking
  useEffect(() => {
    if (router.query.redirectFrom === 'booking') {
      flashActions.addMessage(t('flash.authNeededBeforeBook'), {
        type: 'error',
        sticky: false,
        autoDisappear: true,
      });
    }
  }, []);

  return (
    <div className="signup-content-wrapper bg-light-gray">
      <Head>
        <title>{t('title.signup')}</title>
        <meta name="description" content={t('description.signup')} />
      </Head>
      <div className="px-2 sm:px-4 lg:px-8 pt-6 pb-8 md:pt-12 md:pb-16">
        <Signup {...(props as any)} />
      </div>
    </div>
  );
};

export async function getServerSideProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      // Will be passed to the page component as props
    },
  };
}

const wrapped = GuestConstraintRoute(withTranslation('common')(SignupWrapper));
export default connect(mapStateToProps, mapDispatchToProps)(wrapped);
